<template>
  <div class="info-n2 px-2 py-4">
    <!-- Dashboard header stats -->
    <v-row class="mb-5">
      <v-col cols="12" md="6">
        <v-card class="elevation-1 d-flex align-center pa-4 rounded-lg">
          <v-icon x-large color="primary" class="mr-4">mdi-account-group</v-icon>
          <div>
            <div class="text-subtitle-1 grey--text text--darken-1">Total Trabajadores</div>
            <div class="text-h4 font-weight-bold">{{ totalUsers }}</div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="elevation-1 d-flex align-center pa-4 rounded-lg">
          <v-icon x-large color="error" class="mr-4">mdi-alert-circle</v-icon>
          <div>
            <div class="text-subtitle-1 grey--text text--darken-1">Incidencias Sin Resolver</div>
            <div class="text-h4 font-weight-bold error--text">{{ totalIncidences }}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Data table -->
    <v-card class="elevation-1 pa-4 rounded-lg">
      <div class="d-flex align-center justify-space-between mb-4">
        <h3 class="text-h6 font-weight-regular primary--text">Plantilla Actual</h3>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por nombre, apellidos, o NIF" single-line
          hide-details outlined dense class="shrink ml-auto" style="max-width: 300px"></v-text-field>
      </div>

      <v-data-table :headers="headers" :items="users" :search="search" :loading="loading"
        loading-text="Cargando trabajadores..." :items-per-page="10" :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Trabajadores por página'
        }">
        <template v-slot:[`item.avatar`]="{ item }">
          <v-avatar color="primary" size="32">
            <span class="white--text font-weight-medium">{{ item.name ? item.name.charAt(0).toUpperCase() :
              '' }}{{ item.lastName1 ? item.lastName1.charAt(0).toUpperCase() : '' }}</span>
          </v-avatar>
        </template>
        <template v-slot:[`item.fullName`]="{ item }">
          <div class="font-weight-medium">{{ item.name }} {{ item.lastName1 }} {{ item.lastName2 || '' }}
          </div>
          <div class="text-caption grey--text">{{ item.email }}</div>
        </template>
        <template v-slot:[`item.phone`]="{ item }">
          {{ item.phone || '-' }}
        </template>
        <template v-slot:[`item.n2Codes`]="{ item }">
          <v-chip small color="primary" outlined class="ma-1">
            {{ item.n2Codes ? item.n2Codes.length : 0 }} códigos
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import workcenterService from '@/services/workcenter.service';
import scheduleService from '@/services/schedule.service';

export default {
  name: 'InfoN2',
  props: {
    workcenterId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      users: [],
      totalUsers: 0,
      totalIncidences: 0,
      search: '',
      headers: [
        {
          text: '', value: 'avatar', sortable: false, width: '60px',
        },
        { text: 'Trabajador', value: 'fullName', sortable: false },
        { text: 'DNI / NIF', value: 'idDocument' },
        { text: 'Teléfono', value: 'phone' },
        {
          text: 'Códigos N2/N3', value: 'n2Codes', sortable: false, align: 'center',
        },
      ],
    };
  },
  watch: {
    workcenterId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchData();
        }
      },
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const [workersResponse, incidencesCount] = await Promise.all([
          workcenterService.getWorkers({
            size: 999, workCenter: this.workcenterId, sort: 'name', direction: 'asc',
          }),
          scheduleService.countUnsolvedIncidencesByWorkCenter(this.workcenterId),
        ]);

        this.users = workersResponse.content || [];
        this.totalUsers = this.users.length;
        this.totalIncidences = incidencesCount || 0;
      } catch (error) {
        console.error('Error fetching InfoN2 data:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
